export enum InvestmentStatus {
  UPCOMING = 'upcoming',
  OPEN = 'open',
  CLOSED = 'closed',
  COMPLETED = 'completed',
  EXITED = 'exited',
}
